'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimFindIndex() {
	var polyfill = getPolyfill();

	define(Array.prototype, { findIndex: polyfill }, {
		findIndex: function () {
			return Array.prototype.findIndex !== polyfill;
		}
	});

	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/shim.js
// module id = 265
// module chunks = 3